export enum Languages {
    English = 'en',
    French = 'fr',
    Portugese = 'pt',
    Chinese = 'zh',
}
